module.exports = __webpack_public_path__ + "img/buzzloading2.85d335af.svg";